module.exports = __webpack_public_path__ + "static/hammer-6dc59211493f5be65c64df5648f7883c.jpg";